import React, { useState } from "react";
import {
  Button,
  Typography,
  Grid,
  Container,
  TextField,
  InputAdornment,
} from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";
import { useTranslation } from "react-i18next";
import { handleMobileKeyDown } from "../../globals/utils";

export default function AddVLE() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    full_name: "",
    address: "",
    mobile: "",
    email_id_mobile: "",
    pan_number: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post("/areamanager/add-vle/", formData);
      showAlert("success", response.data.message);
      navigate("/area-manager/vles"); // Redirect to VLE list
    } catch (error) {
      showAlert(
        "error",
        error.response?.data?.error || "An error occurred while adding the VLE."
      );
    }
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid
          container
          justify="center"
          direction="column"
          style={{ marginTop: "20px" }}
        >
          <Typography variant="h5">{t("Add VLE")}</Typography>
          <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("Full Name")}
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("Address")}
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  multiline
                  rows={3}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("Mobile Number")}
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  type="tel"
                  inputProps={{
                    maxLength: 10,
                    inputMode: "numeric",
                  }}
                  onKeyDown={handleMobileKeyDown}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">+91</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("Email ID")}
                  name="email_id_mobile"
                  value={formData.email_id_mobile}
                  onChange={handleChange}
                  type="email"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("PAN Number")}
                  name="pan_number"
                  value={formData.pan_number}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  {t("Add VLE")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Container>
    </>
  );
}
